import { bem } from '@socialive/common';
import PropTypes from 'prop-types';
import LoadingIcon from '../../Icons/LoadingIcon';
import './image.css';

function Image({ src, className, alt, ...other }) {
  return (
    <div className={bem`img ${className}`} {...other}>
      {src && <img alt={alt} src={src} className="img__content" />}
      {!src && (
        <div className="img__placeholder">
          <LoadingIcon className="img__placeholderIcon" />
        </div>
      )}
    </div>
  );
}

Image.propTypes = {
  alt: PropTypes.string,
  src: PropTypes.string,
  className: PropTypes.string,
};

Image.defaultProps = {
  alt: undefined,
  src: undefined,
  className: undefined,
};

export default Image;
